import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";

export type TDevice = {
  id: string;
  createdAt: string;
  deviceName: string;
  displayOrder: number;
  isDoorBellEnabled: boolean;
  isWalkInVisitEnabled: boolean;
  isInfoMessageEnabled: boolean;
  isGreetingDefault: boolean;
  visitorsSettingTheme: {
    id: string;
    primary: string;
  };
};

export type TDeviceConfig = {
  id: string;
  deviceName: string;
  displayOrder: number;
};

export type THomeSetting = {
  id: string;
  createdAt: string;
  deviceName: string;
  displayOrder: number;
  isDoorBellEnabled: boolean;
  isWalkInVisitEnabled: boolean;
  isInfoMessageEnabled: boolean;
  isGreetingDefault: boolean;
  greetingInKorFormat: string;
  greetingInEngFormat: string;
  infoMessageInKorFormat: string;
  infoMessageInEngFormat: string;
  visitorsSettingTheme: {
    id: string;
    primary: string;
  };
};

export const getDeviceList = async (): Promise<TDevice[]> => {
  try {
    const res = await instance.get("/visitors/setting/device");

    return res.data;
  } catch (error) {
    return [];
  }
};

export const updateDeviceName = async (device: TDevice): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/name", {
      id: device.id,
      deviceName: device.deviceName,
    });
    return res.data.result;
  } catch (error: any) {
    if (error && error.response.status === 409) {
      alert("기기명이 중복되었습니다.");
    }
    return false;
  }
};

export const getImportConfigDevices = async (deviceId: string): Promise<TDeviceConfig[]> => {
  try {
    const res = await instance.post("/visitors/setting/device/import-config", {
      id: deviceId,
    });
    return res.data;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId } });
    return [];
  }
};

export const setImportConfigDevices = async (targetId: string, overrideId: string): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/import-config", {
      targetVisitorsDeviceId: targetId,
      overrideVisitorsDeviceId: overrideId,
    });
    return res.data.result;
  } catch (error) {
    return false;
  }
};

export const getHomeSettingInfo = async (deviceId: string): Promise<THomeSetting | undefined> => {
  try {
    const res = await instance.post("/visitors/setting/device/home", {
      id: deviceId,
    });
    return res.data;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId } });
  }
};

export const updateHomeSettingInfo = async (homeSetting: THomeSetting): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/home", homeSetting);
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: homeSetting } });
    return false;
  }
};
